import { call, put, select, takeLatest } from 'redux-saga/effects'
import { apiCall } from '../../../common/api/api'
import {
  OrderedMedidasMoto,
  setOpcionesMedidas,
  setMedidasIniciales,
  updateMedidaSeleccionada,
} from './medidasMoto.slice'
import { selectSelectedMedidasMoto } from './medidasMoto.selectors'

type MedidaRequestMoto = {
  name: (typeof OrderedMedidasMoto)[number]
  value: string | number | null | undefined
}

type OptionMedida = {
  label: string
  value: string
  principal?: boolean
  orden?: number
}

type ResponseTyresMoto = {
  ancho: OptionMedida[] | { output?: OptionMedida[]; hasResults?: boolean }
  alto: OptionMedida[] | { output?: OptionMedida[]; hasResults?: boolean }
  llanta: OptionMedida[] | { output?: OptionMedida[]; hasResults?: boolean }
  filterables: {
    marcas: OptionMedida[] | { output?: OptionMedida[]; hasResults?: boolean }
    tipos: OptionMedida[] | { output?: OptionMedida[]; hasResults?: boolean }
    gamas: OptionMedida[] | { output?: OptionMedida[]; hasResults?: boolean }
  }
}

const baseUrl = `${process.env.GATSBY_API_URL}`

function normalizeOptions(input: unknown): OptionMedida[] {
  if (Array.isArray(input)) return input as OptionMedida[]
  if (
    input &&
    typeof input === 'object' &&
    Array.isArray((input as { output?: OptionMedida[] }).output)
  ) {
    return (input as { output: OptionMedida[] }).output
  }
  return []
}

function* buscarMedidasSagaMoto() {
  try {
    const selectedMedidas = yield select(selectSelectedMedidasMoto)

    const medidas: MedidaRequestMoto[] = OrderedMedidasMoto.map((name) => ({
      name,
      value: selectedMedidas[name],
    }))

    const query = medidas.map((m) => {
      return `${encodeURIComponent(m.name)}=${encodeURIComponent(
        m.value == null ? 'null' : String(m.value)
      )}`
    })

    const items: ResponseTyresMoto = yield call(
      apiCall,
      `${baseUrl}/tyres-with-values-moto?${query.join('&')}`
    )

    const opciones = {
      ancho: {
        loading: false,
        value: selectedMedidas.ancho ?? null,
        default: null,
        options: normalizeOptions(items.ancho).map((o) => ({
          label: o.label,
          value: o.value,
        })),
      },
      alto: {
        loading: false,
        value: selectedMedidas.alto ?? null,
        default: null,
        options: normalizeOptions(items.alto).map((o) => ({
          label: o.label,
          value: o.value,
        })),
      },
      llanta: {
        loading: false,
        value: selectedMedidas.llanta ?? null,
        default: null,
        options: normalizeOptions(items.llanta).map((o) => ({
          label: o.label,
          value: o.value,
        })),
      },
    }

    yield put(setOpcionesMedidas(opciones))
  } catch (err) {
    // Avoid breaking the UI on API issues.
    // eslint-disable-next-line no-console
    console.error('Error cargando opciones moto:', err)
  }
}

export function* medidasMotoSaga() {
  yield takeLatest(updateMedidaSeleccionada.type, buscarMedidasSagaMoto)
  yield takeLatest(setMedidasIniciales.type, buscarMedidasSagaMoto)
}
